export default __webpack_public_path__ + "static/media/splash.0af2d0af.png";